"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addPersonalSubscriptionHandler = addPersonalSubscriptionHandler;
var AddPersonalSubscriptionFailed = _interopRequireWildcard(require("@ori-events/add-personal-subscription-failed"));
var AddToBasket = _interopRequireWildcard(require("@ori-events/add-to-basket"));
var RemoveBasketItemFailed = _interopRequireWildcard(require("@ori-events/remove-basket-item-failed"));
var UpdateBasketItemFailed = _interopRequireWildcard(require("@ori-events/update-basket-item-failed"));
var _checkoutUtils = require("@ori/checkout-utils");
var _api = require("../api");
var _logger = require("../logger");
var _types = require("../types");
var _utils = require("../utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
async function addPersonalSubscriptionHandler({
  detail: {
    itemCode,
    items,
    frequency,
    placement,
    lineNumber,
    originalQuantity
  }
}, {
  client,
  sessionId,
  tenant
}) {
  const globalShoppingPersonalSubscriptionDto = {
    itemCode,
    collection: items ?? [],
    frequency,
    status: 'New'
  };

  // STEP 1 - Remove or reduce quanity of original item in basket
  // This step needs to be done first as the AddPersonalSubscription endpoint will change the lineNumber of items in the basket
  if (typeof lineNumber === 'number' && originalQuantity !== undefined && originalQuantity > 1) {
    await fetch(`${_types.RequestUrl.UpdateBasketItem}?lineNumber=${lineNumber}&quantity=${originalQuantity - 1}`, (0, _utils.getHttpRequestSettings)({
      placement
    }));
  } else if (typeof lineNumber === 'number' && originalQuantity !== undefined && originalQuantity === 1) {
    await fetch(_types.RequestUrl.RemoveBasketItem, (0, _utils.getHttpRequestSettings)({
      lineNumber,
      placement
    }, _checkoutUtils.HttpMethod.Post));
  }

  // STEP 2 - Add personal subscription
  try {
    await (0, _api.addPersonalSubscription)({
      client,
      globalShoppingPersonalSubscriptionDto,
      sessionId,
      tenant,
      placement,
      referer: (0, _utils.getReferer)()
    });
  } catch (error) {
    _logger.mainLogger.error(error, {
      message: 'Error while adding personal subscription in addPersonalSubscription event'
    });
    const errorEvent = new CustomEvent(AddPersonalSubscriptionFailed.Name, {
      detail: {
        isSuccess: false,
        localizedMessage: String(error),
        message: String(error)
      }
    });
    window.dispatchEvent(errorEvent);

    // STEP 2error - Revert the remove/reduce action from STEP 1
    if (typeof lineNumber === 'number' && originalQuantity !== undefined && originalQuantity > 1) {
      await fetch(`${_types.RequestUrl.UpdateBasketItem}?lineNumber=${lineNumber}&quantity=${originalQuantity + 1}`, (0, _utils.getHttpRequestSettings)({
        placement
      }));
    } else if (typeof lineNumber === 'number' && originalQuantity !== undefined && originalQuantity === 1) {
      await fetch(_types.RequestUrl.AddToBasketForMoney, (0, _utils.getHttpRequestSettings)({
        itemCode,
        quantity: 1,
        method: AddToBasket.Method.BUY_FOR_MONEY,
        placement
      }, _checkoutUtils.HttpMethod.Post));
    } else {
      // return in case of no basket item manipulation, update is needed otherwise
      return false;
    }
  }

  // STEP 4 - Update shopping context via Online endpoint
  const response = await fetch(_types.RequestUrl.GetShoppingContext, (0, _utils.getHttpRequestSettings)(undefined, _checkoutUtils.HttpMethod.Post));
  const data = (0, _utils.convertToCamelCase)(await response.json());
  if (AddPersonalSubscriptionFailed.isAddPersonalSubscriptionErrorResponse(data)) {
    const errorEvent = new CustomEvent(AddPersonalSubscriptionFailed.Name, {
      detail: data
    });
    window.dispatchEvent(errorEvent);
    return false;
  } else if (RemoveBasketItemFailed.isRemoveBasketItemErrorResponse(data)) {
    const errorEvent = new CustomEvent(RemoveBasketItemFailed.Name, {
      detail: data
    });
    window.dispatchEvent(errorEvent);
    return false;
  } else if (UpdateBasketItemFailed.isUpdateBasketItemErrorResponse(data)) {
    const errorEvent = new CustomEvent(UpdateBasketItemFailed.Name, {
      detail: data
    });
    window.dispatchEvent(errorEvent);
    return false;
  }
  return {
    ...data,
    isPersonalNutritionAddedAsLast: data.shoppingBag.shoppingBagItems[0]?.itemType === 'n',
    lastAddedItem: {
      itemCode,
      method: AddToBasket.Method.BUY_FOR_MONEY,
      quantity: 1,
      frequency
    }
  };
}
